import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { initialState as goldInitialState } from '~redux/slices/gold';

import { TGetSerialNumberListingFilter } from '~types/feat/gold';

import SearchAndFilterBar, { TSearchAndFilterBarProps } from '~components/molecules/SearchAndFilterBar';

import * as Styles from './_serialNumberSearchAndFilterBar.module.scss';
import { MetalTypeEnum } from '~utils/enums';

const SerialNumberSearchAndFilterBar = () => {
    const dispatch = useAppDispatch();

    const filters = useAppSelector(state => state.gold.serialNumber.serialNumberListing.filters);

    const initialFilters = goldInitialState.serialNumber.serialNumberListing.filters;

    const setFilters = (inputFilters: TGetSerialNumberListingFilter) => dispatch(combinedActions.goldSetSerialNumberListingFilters(inputFilters));
    const handleSearchClick = () => dispatch(combinedActions.goldGetSerialNumberListingAttempt());
    const handleCancelClick = () => {
        setFilters({
            ...initialFilters,
        });
        dispatch(combinedActions.goldGetSerialNumberListingAttempt());
    };

    const fields: TSearchAndFilterBarProps['fields'] = [

        {
            label: 'Metal Type:',
            type: 'dropdown' as const,
            dropdownParams: {
                options: [
                    {
                        label: 'Gold',
                        value: MetalTypeEnum.Gold,
                    },
                    {
                        label: 'Silver',
                        value: MetalTypeEnum.Silver,
                    },
                ],
                value: filters.metalType,
                setValue: (event: React.ChangeEvent<HTMLInputElement>) => setFilters({ ...filters, metalType: event.target.value }),
                optionSelected: !!MetalTypeEnum[filters.metalType as keyof typeof MetalTypeEnum],
                noOptionsMessage: 'No metal type found',
            },
        },
        {
            label: 'Serial Number:',
            type: 'input' as const,
            inputParams: {
                value: filters.serialNo || '',
                setValue: (event) => setFilters({ ...filters, serialNo: event.target.value }),
                onKeyDown: (event) => { if (event.key === 'Enter') handleSearchClick(); },
                className: Styles.input,
                testId: 'serial-number-search-input'
            },
        },
    ];

    return (
        <SearchAndFilterBar
            fields={fields}
            searchOnClick={handleSearchClick}
            cancelOnClick={handleCancelClick}
            containerClassName={Styles['content-container']}
        />
    );
};

export default SerialNumberSearchAndFilterBar;
